import Logger from 'js-logger';

import config from '../constants/Config';

import DebugUtils from '../utils/debug/DebugUtils';
import StateMachine from '../utils/statemachine/StateMachine';

import GameStartState from './game/GameStartState';
import GamePlayState from './game/GamePlayState';
import GameOverState from './game/GameOverState';

import GameScreen from '../display/GameScreen';
import SplashScreen from '../display/SplashScreen';

const GameState = function () {

  // there are times when init() is called twice, not sure why
  // but don't go there
  this._initialized = false;
  this._created = false;
};

/////////////////////////////////////////////////////////////////////////
// CONSTANTS ////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////
GameState.STATE_GAME_START  = 'State:Game:Start';
GameState.STATE_GAME_PLAY  = 'State:Game:Play';
GameState.STATE_GAME_OVER   = 'State:Game:Over';


/////////////////////////////////////////////////////////////////////////
// MEMBERS ////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////
GameState.prototype = {

	constructor: GameState,

	preload: function () {

	},

	/**
	**/
	init: function() {
        if (this._initialized)
          return;

        Logger.info('init GameState');

        // Create ui container
        this._createContainer();

		// initial draw - redraw whenever screen size changes
		this.drawAll();

		// this is the 'PhaserUtils' state machine, not the Phaser
		this.stateMachine = Object.create(StateMachine).init();

        // create the sub-states
        // TODO - create a 'State factory' that lets us setup() and create in one call
        this.gameStart = Object.create(GameStartState).setup(this.game);
        this.gamePlay = Object.create(GamePlayState).setup(this.game);
        this.gameOver = Object.create(GameOverState).setup(this.game);

        // signal handlers
        this.gameStart.onSignalGamePlayStart.add(this.handleStart, this);
        this.gamePlay.onSignalGameEnd.add(this.handleEnd, this);
        this.gameOver.onSignalGameReady.add(this.handleReady, this);
        this.gameOver.onSignalGameOverExit.add(this.handleExit, this);

        // bind states to symbols
        this.stateMachine.bindState(GameState.STATE_GAME_START, this.gameStart);
        this.stateMachine.bindState(GameState.STATE_GAME_PLAY, this.gamePlay);
        this.stateMachine.bindState(GameState.STATE_GAME_OVER, this.gameOver);

        this._initialized = true;
	},

	create: function () {
        if (this._created || !this._initialized)
          return;

        Logger.info('enter GameState');

        // debug- show fps window and init hot keys
        if (config.debug) {
            DebugUtils.create();
        }

        // listen for size changes
        this.scale.onSizeChange.add(this.handleGameSizeChanged, this);

        // reset display
        this.game.display.gameScreen.reset();
        this.game.display.splashScreen.reset();

        // start game
        this.stateMachine.switchState(GameState.STATE_GAME_START);

        this._created = true;
	},

	update: function () {
        // help us out
        this.game.time.elapsedSeconds = this.game.time.elapsedMS / 1000;

        // update sub-state
        this.stateMachine.getCurrentState().update();

        // update global ui
        //this.game.display.background.frameUpdate();
        this.game.display.gameScreen.frameUpdate();
	},

    /**
    * Nearly all display objects in Phaser render automatically, you don't need to tell them to render.
    * However the render method is called AFTER the game renderer and plugins have rendered, so you're able to do any
    * final post-processing style effects here. Note that this happens before plugins postRender takes place.
    *
    * @method Phaser.State#render
    */
	render: function() {
		if (config.debug && DebugUtils.fpsView) {
            DebugUtils.fpsView.render();
		}
	},

	shutdown: function() {

		this.stateMachine.getCurrentState().onExit();

    this._created = false;
	},

    drawAll: function() {
        // center ui (maybe)
        var display = this.game.display;

        display.x = 0;

        //display.background.draw();
        display.gameScreen.draw();
        display.splashScreen.draw();
    },

	/////////////////////////////////////////////////////////////////////////
	// HELPERS //////////////////////////////////////////////////////////////
	/////////////////////////////////////////////////////////////////////////
    _createContainer: function() {

        // create a group that contains all display/ui elements
        this.game.display = this.game.add.group();

        var display = this.game.display;

        //display.background = new Background(this.game);
        display.gameScreen = new GameScreen(this.game);
        display.splashScreen = new SplashScreen(this.game);

        // add particle-storm at ui level
        display.particleStorm = this.game.plugins.add(Phaser.ParticleStorm);

        //display.add(display.background);
        display.add(display.gameScreen);
        display.add(display.splashScreen);

        display.gameScreen.init();
        display.splashScreen.init();

    },

	/////////////////////////////////////////////////////////////////////////
	// EVENT HANDLERS ///////////////////////////////////////////////////////
	/////////////////////////////////////////////////////////////////////////

    handleStart: function() {
        // start reel spins
        this.stateMachine.switchState(GameState.STATE_GAME_PLAY);
    },

    handleEnd: function() {
        // game over
        this.stateMachine.switchState((GameScreen.USE_3D) ? GameState.STATE_GAME_START : GameState.STATE_GAME_OVER);
    },

    handleReady: function() {
        // reset display
        this.game.display.gameScreen.reset();
        this.game.display.splashScreen.reset();

        // go back to start
        this.stateMachine.switchState(GameState.STATE_GAME_START);
    },

    handleGameSizeChanged: function() {
        // redraw - this would be a reason to make 'ui' a functioning object
        this.drawAll();
    },

    handleExit: function(error) {
        window.backToLottery(error);
    }
};

export default GameState;



// WEBPACK FOOTER //
// ./app/src/states/GameState.js